import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 1. Import the registration tool
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// React Query
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);


serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration.waiting) {
      // Fire a custom event so UpdatePrompt can pick it up
      window.dispatchEvent(
        new CustomEvent('sw-update-available', { detail: registration.waiting })
      );
    }
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
